import { Box, styled } from '@mui/material';
import React from 'react';

import { COLORS } from '../../../../../../configs/colors';
import { SlideProps } from '../SwipeableServiceCard.props';

const ReferenceGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '4px 12px',
});

const ReferenceCell = styled(Box)({
  minWidth: 0,
  overflow: 'hidden',
});

const InfoLabel = styled(Box)({
  fontWeight: 600,
  fontSize: '0.65rem',
  textTransform: 'uppercase',
  letterSpacing: '0.8px',
  color: COLORS.LightGrey,
  marginBottom: '3px',
});

const InfoValue = styled(Box)({
  fontSize: '0.85rem',
  color: COLORS.Black,
  marginBottom: '2px',
  fontWeight: 500,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
});

const NoReferences = styled(Box)({
  fontSize: '0.85rem',
  color: COLORS.LightGrey,
  fontStyle: 'italic',
  textAlign: 'center',
  padding: '20px 0',
});

export const ReferencesSlide: React.FC<SlideProps> = ({ service, zone }) => {
  const hasLocRefs = service.nodeReference1 || service.nodeReference2 || service.nodeReference3;
  const hasJobRefs = service.reference1 || service.reference2 || service.reference3;

  if (!hasLocRefs && !hasJobRefs) {
    return (
      <Box data-slide="2">
        <NoReferences>No references available</NoReferences>
      </Box>
    );
  }

  return (
    <Box data-slide="2">
      <ReferenceGrid>
        <ReferenceCell>
          <InfoLabel>Loc Ref 1</InfoLabel>
          <InfoValue>{service.nodeReference1 || '-'}</InfoValue>
          <InfoLabel>Loc Ref 2</InfoLabel>
          <InfoValue>{service.nodeReference2 || '-'}</InfoValue>
          <InfoLabel>Loc Ref 3</InfoLabel>
          <InfoValue>{service.nodeReference3 || '-'}</InfoValue>
        </ReferenceCell>
        <ReferenceCell>
          <InfoLabel>Job Ref 1</InfoLabel>
          <InfoValue>{service.reference1 || '-'}</InfoValue>
          <InfoLabel>Job Ref 2</InfoLabel>
          <InfoValue>{service.reference2 || '-'}</InfoValue>
          <InfoLabel>Job Ref 3</InfoLabel>
          <InfoValue>{service.reference3 || '-'}</InfoValue>
        </ReferenceCell>
      </ReferenceGrid>
      {zone && (
        <Box sx={{ marginTop: '4px' }}>
          <InfoLabel>Zone</InfoLabel>
          <InfoValue>{zone}</InfoValue>
        </Box>
      )}
    </Box>
  );
};
